var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6291 60L93.3146 33.3146L86.6854 26.6854L60 53.3709L33.3146 26.6854L26.6854 33.3146L53.3709 60L26.6854 86.6854L33.3146 93.3146L60 66.6291L86.6854 93.3146L93.3146 86.6854L66.6291 60Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.629 60L213.315 33.3146L206.685 26.6854L180 53.3709L153.315 26.6854L146.685 33.3146L173.371 60L146.685 86.6854L153.315 93.3146L180 66.6291L206.685 93.3146L213.315 86.6854L186.629 60Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.629 60L333.315 33.3146L326.685 26.6854L300 53.3709L273.315 26.6854L266.685 33.3146L293.371 60L266.685 86.6854L273.315 93.3146L300 66.6291L326.685 93.3146L333.315 86.6854L306.629 60Z",
    fill: "#121212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.629 60L453.315 33.3146L446.685 26.6854L420 53.3709L393.315 26.6854L386.685 33.3146L413.371 60L386.685 86.6854L393.315 93.3146L420 66.6291L446.685 93.3146L453.315 86.6854L426.629 60Z",
    fill: "#121212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.629 60L573.315 33.3146L566.686 26.6854L540 53.3709L513.315 26.6854L506.686 33.3146L533.371 60L506.686 86.6854L513.315 93.3146L540 66.6291L566.686 93.3146L573.315 86.6854L546.629 60Z",
    fill: "#121212"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6291 180L93.3146 153.315L86.6854 146.685L60 173.371L33.3146 146.685L26.6854 153.315L53.3709 180L26.6854 206.685L33.3146 213.315L60 186.629L86.6854 213.315L93.3146 206.685L66.6291 180Z",
    fill: "#121212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.629 180L213.315 153.315L206.685 146.685L180 173.371L153.315 146.685L146.685 153.315L173.371 180L146.685 206.685L153.315 213.315L180 186.629L206.685 213.315L213.315 206.685L186.629 180Z",
    fill: "#121212"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.629 180L333.315 153.315L326.685 146.685L300 173.371L273.315 146.685L266.685 153.315L293.371 180L266.685 206.685L273.315 213.315L300 186.629L326.685 213.315L333.315 206.685L306.629 180Z",
    fill: "#121212"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.629 180L453.315 153.315L446.685 146.685L420 173.371L393.315 146.685L386.685 153.315L413.371 180L386.685 206.685L393.315 213.315L420 186.629L446.685 213.315L453.315 206.685L426.629 180Z",
    fill: "#121212"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.629 180L573.315 153.315L566.686 146.685L540 173.371L513.315 146.685L506.686 153.315L533.371 180L506.686 206.685L513.315 213.315L540 186.629L566.686 213.315L573.315 206.685L546.629 180Z",
    fill: "#121212"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6291 300L93.3146 273.315L86.6854 266.685L60 293.371L33.3146 266.685L26.6854 273.315L53.3709 300L26.6854 326.685L33.3146 333.315L60 306.629L86.6854 333.315L93.3146 326.685L66.6291 300Z",
    fill: "#121212"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.629 300L213.315 273.315L206.685 266.685L180 293.371L153.315 266.685L146.685 273.315L173.371 300L146.685 326.685L153.315 333.315L180 306.629L206.685 333.315L213.315 326.685L186.629 300Z",
    fill: "#121212"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.629 300L333.315 273.315L326.685 266.685L300 293.371L273.315 266.685L266.685 273.315L293.371 300L266.685 326.685L273.315 333.315L300 306.629L326.685 333.315L333.315 326.685L306.629 300Z",
    fill: "#121212"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.629 300L453.315 273.315L446.685 266.685L420 293.371L393.315 266.685L386.685 273.315L413.371 300L386.685 326.685L393.315 333.315L420 306.629L446.685 333.315L453.315 326.685L426.629 300Z",
    fill: "#121212"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.629 300L573.315 273.315L566.686 266.685L540 293.371L513.315 266.685L506.686 273.315L533.371 300L506.686 326.685L513.315 333.315L540 306.629L566.686 333.315L573.315 326.685L546.629 300Z",
    fill: "#121212"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6291 420L93.3146 393.315L86.6854 386.685L60 413.371L33.3146 386.685L26.6854 393.315L53.3709 420L26.6854 446.685L33.3146 453.315L60 426.629L86.6854 453.315L93.3146 446.685L66.6291 420Z",
    fill: "#121212"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.629 420L213.315 393.315L206.685 386.685L180 413.371L153.315 386.685L146.685 393.315L173.371 420L146.685 446.685L153.315 453.315L180 426.629L206.685 453.315L213.315 446.685L186.629 420Z",
    fill: "#121212"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.629 420L333.315 393.315L326.685 386.685L300 413.371L273.315 386.685L266.685 393.315L293.371 420L266.685 446.685L273.315 453.315L300 426.629L326.685 453.315L333.315 446.685L306.629 420Z",
    fill: "#121212"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.629 420L453.315 393.315L446.685 386.685L420 413.371L393.315 386.685L386.685 393.315L413.371 420L386.685 446.685L393.315 453.315L420 426.629L446.685 453.315L453.315 446.685L426.629 420Z",
    fill: "#121212"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.629 420L573.315 393.315L566.686 386.685L540 413.371L513.315 386.685L506.686 393.315L533.371 420L506.686 446.685L513.315 453.315L540 426.629L566.686 453.315L573.315 446.685L546.629 420Z",
    fill: "#121212"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6291 540L93.3146 513.315L86.6854 506.685L60 533.371L33.3146 506.685L26.6854 513.315L53.3709 540L26.6854 566.685L33.3146 573.315L60 546.629L86.6854 573.315L93.3146 566.685L66.6291 540Z",
    fill: "#121212"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.629 540L213.315 513.315L206.685 506.685L180 533.371L153.315 506.685L146.685 513.315L173.371 540L146.685 566.685L153.315 573.315L180 546.629L206.685 573.315L213.315 566.685L186.629 540Z",
    fill: "#121212"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.629 540L333.315 513.315L326.685 506.685L300 533.371L273.315 506.685L266.685 513.315L293.371 540L266.685 566.685L273.315 573.315L300 546.629L326.685 573.315L333.315 566.685L306.629 540Z",
    fill: "#121212"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.629 540L453.315 513.315L446.685 506.685L420 533.371L393.315 506.685L386.685 513.315L413.371 540L386.685 566.685L393.315 573.315L420 546.629L446.685 573.315L453.315 566.685L426.629 540Z",
    fill: "#121212"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.629 540L573.315 513.315L566.686 506.685L540 533.371L513.315 506.685L506.686 513.315L533.371 540L506.686 566.685L513.315 573.315L540 546.629L566.686 573.315L573.315 566.685L546.629 540Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPattern);
export default __webpack_public_path__ + "static/media/cross-pattern.216830263ea49aadbaa1aa00beb5d9cc.svg";
export { ForwardRef as ReactComponent };